import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import { CaretDownSolidIcon } from '../../../images/shapes';

const TopNavPopover = ({ label, items, isFeatures = false, testId = '' }) => (
  <div className="relative">
    <button className="peer pl-2 py-4 hover:text-blue group/nav-popover">
      {label}
      <CaretDownSolidIcon
        className="w-2.5 h-2.5 inline ml-1 text-blue group-hover/nav-popover:rotate-180
                  transition-transform duration-300 mr-3 2xl:mr-8"
      />
    </button>
    <ul
      className={twMerge(
        'hidden absolute bg-white dark:bg-slate-800 rounded-lg shadow-nav py-2.5 font-medium',
        'before:content[""] before:absolute before:h-4 before:w-4 before:bg-white dark:before:bg-slate-800',
        'before:rotate-45 before:translate-y-1/2 before:bottom-full before:rounded-tl',
        isFeatures
          ? 'peer-hover:flex hover:flex flex-wrap fixed left-1/2 -translate-x-1/2 ' +
              'w-[calc(100vw-60px)] before:left-64 before:translate-x-1/2'
          : 'peer-hover:block hover:block before:left-1/2 before:-translate-x-1/2 -translate-x-8',
      )}
    >
      {items.map(({ key, label, url, iconUrl, newTab }) => (
        <li
          className={twMerge(
            'flex min-w-max',
            isFeatures && 'basis-1/2 xl:basis-1/3',
          )}
          key={key}
        >
          <Link
            className={twMerge(
              'flex w-full items-center',
              'hover:no-underline hover:text-blue focus:no-underline focus:text-blue',
              isFeatures ? 'p-4 pl-5' : ' py-3 pl-6 pr-10',
            )}
            to={url}
            {...(newTab ? { target: '_blank', rel: 'noreferrer' } : {})}
            {...getTestProps(testId, `link-${key}`)}
          >
            {iconUrl && (
              <span className="w-20">
                <img className="w-9" alt={label} src={iconUrl} />
              </span>
            )}
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default TopNavPopover;
